import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('AccountingInvoiceProfileModel')
export default class AccountingInvoiceProfileModel {
  @JsonProperty('id', Number) public id:number = undefined;
  @JsonProperty('name', String) public name:string = undefined;
}